import TileWrapper from '../TileWrapper'
import { useTeam } from 'app/frontend/base/config/context/team'
import { useMembersByRole } from '../../../TeamRoster/hooks'
import RosterSetup, {
  RosterSetupContext,
} from '../../../TeamRoster/components/RosterSetup'
import CountByClass from '../../../TeamRoster/components/RosterStats/CountByClass'
import TotalCharacters from '../../../TeamRoster/components/RosterStats/TotalCharacters'
import ArmorTypes from '../../../TeamRoster/components/RosterStats/ArmorTypes'
import { useTile } from '../../context'
import RosterStats from '../../../TeamRoster/components/RosterStats'
import { Badge } from '@/components/ui/badge'

import ByRole from './RosterSummary/ByRole'
import FullList from './RosterSummary/FullList'
import { useMemo } from 'react'

export const SIDEBAR_OPTIONS = [
  {
    value: 'total_count',
    label: 'Total character count',
    component: TotalCharacters,
  },
  { value: 'full_list', label: 'All main characters', component: FullList },
  { value: 'by_role', label: 'Role summary', component: ByRole },
  { value: 'by_class', label: 'Class summary', component: CountByClass },
  {
    value: 'by_armor_type',
    label: 'Armor type summary',
    component: ArmorTypes,
  },
]

export const MAIN_OPTIONS = [
  {
    value: 'stats',
    label: 'Roster stats',
    component: RosterStats,
  },
  { value: 'roster', label: 'Full roster', component: RosterSetup },
  { value: 'by_role', label: 'Role summary', component: ByRole },
]

const RosterSummaryTile = () => {
  const { team } = useTeam()
  const { tile } = useTile()
  const excludedTeamRankIds = useMemo(
    () => team.teamRanks?.filter((r) => !r.roster_visibility).map((r) => r.id),
    [team.teamRanks],
  )
  const filteredMembers = useMemo(
    () =>
      team.members?.filter(
        (member) => !excludedTeamRankIds?.includes(member.teamRank.id),
      ) ?? [],
    [team.members, excludedTeamRankIds],
  )

  const {
    mains,
    mainsByRole,
    alts,
    altsByRole,
    membersWithOffspecs,
    offSpecsByRole,
  } = useMembersByRole(filteredMembers)

  const SidebarComponent =
    SIDEBAR_OPTIONS.find(
      (option) => option.value === tile.config?.sidebar_summary_type,
    )?.component ?? TotalCharacters

  const MainComponent =
    MAIN_OPTIONS.find(
      (option) => option.value === tile.config?.main_summary_type,
    )?.component ?? RosterStats

  return (
    <RosterSetupContext.Provider
      value={{
        charactersById: {},
        mainByUser: {},
        userIdsWithDuplicateMains: [],
        sortedMembers: filteredMembers,
        mains,
        alts,
        membersWithOffspecs,
        mainsByRole,
        altsByRole,
        offSpecsByRole,
      }}
    >
      <TileWrapper
        inContainer={tile.position === 'sidebar'}
        cta={
          <Badge variant='outline' className='text-base'>
            {mains.length}
          </Badge>
        }
      >
        {tile.position === 'sidebar' ? (
          <SidebarComponent className='p-0 bg-transparent hover:bg-transparent border-0' />
        ) : (
          <MainComponent
            forceGrid={true}
            members={filteredMembers}
            compact={true}
          />
        )}
      </TileWrapper>
    </RosterSetupContext.Provider>
  )
}

export default RosterSummaryTile
